import { Container, Grid } from "@material-ui/core";
import Menu from "../../Components/Menu";
import styled from '@emotion/styled'
import Background from "../../img/S3.png"

const S3_Homepage = () => {
    const MainDiv = styled.div`
    /* background-image: url(${Background});
    background-size: cover;
    background-repeat: no-repeat;
    background-position-y: center;
    padding: 113px 0; */
    

    @media screen and (max-width:1311px){
      background-size: contain;
      background-repeat: no-repeat;
      background-position-y: center;
    }
    `
    const Span = styled.span`
    color:#ffffff;
    font-size: 44px;
    text-transform: uppercase;
    font-weight: 600;
    padding-bottom:10px;
    @media screen and (max-width:600px){
      font-size: 30px
    }
    `
    const P = styled.p`
    color: #ffffff;
    max-width:600px;
    
    
  `;
    const MapImg = styled.img`
    width: 100%;
    height: auto;
    
    
  `;
  return (
    <MainDiv className="" id="Home">
      <Container>
        <Grid
          container
          justifyContent="left"
          alignContent="left"
          alignItems="left"
        >
          <Grid xs={12} sm={12} md={12} className="text-left">
            <h1 className="fontweight py-5">
                <Span >
                 <span style={{borderBottom:'7px solid #B82E3C'}}>&nbsp;our</span> presence
                </Span>
            </h1>
            {/* <P>we are starting in Bahrain and would like to cover the region for medium to large scale mega projects with years’ experience in hand we are confident of our success in kingdom of Bahrain.</P>
            <P>solar solutions could be an area we may explore in kingdom of Bahrain and another area would be marine infrastructure or modern agro farming.</P> */}
          </Grid>
        </Grid>
      </Container>
            <MapImg src={Background} />
    </MainDiv>
  );
};

export default S3_Homepage;
